import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

// Routes that don't require authentication
const publicRoutes = ['/access/401', '/access/authentication', '/access/error'];

export const Route = createFileRoute('/access_')({
	beforeLoad: ({ location }) => {
		// Skip auth check for public routes
		if (publicRoutes.some((route) => location.pathname.startsWith(route))) {
			return;
		}

		const authToken = window.sessionStorage.getItem('accessAuthToken');
		if (!authToken) {
			throw redirect({
				to: '/access/401',
			});
		}
	},
	component: AccessLayout,
});

function AccessLayout() {
	return <Outlet />;
}
